import { DataValidator, IsBoolean, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiService } from "./api";

export interface TiktokThirdAccountResponse {
  results: Array<Results>;
  sid?: string;
};

export interface Results {
  id: string;
  name?: string;
  avatar?: string;
  isExpired: boolean;
  lastPublishAt: string;
  platform: string;
};

class ResultsData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsBoolean("Name must be a boolean")
  isExpired?: boolean;
}

class TiktokThirdAccountData {
  @Required("results url cannot be empty")
  results: ResultsData[];
}

const transformAndValidateData = (
  response: TiktokThirdAccountResponse
): TiktokThirdAccountData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, TiktokThirdAccountData);
  } catch (error) {
    console.error("Tiktok third account data validation failed:", error.message);
    throw error;
  }
};

// 获取 TikTok 第三方账号id
export const tiktokThirdAccount = async () => {
  const res = await api.post<TiktokThirdAccountResponse>("/tiktok/third_account");
  return transformAndValidateData(res.data);
};
